import { RecommendationService } from '@/services/recommendation.service'

// Recomendações da matrícula aberta (Story-6066).
//
// Sem cache: a API recalcula a cada acesso (comprou 1 de 10 → no próximo
// acesso vêm 9), então o front busca de novo a cada entrada na página do curso
// ou da aula — quem dispara é o ComposedHeader.
//
// Só guarda UMA matrícula: os itens valem para `enrollId` e o getter devolve
// [] para qualquer outra, o que impede mostrar a recomendação de um curso na
// tela de outro enquanto a nova chamada não volta.
//
// EXIBIÇÃO: uma oferta por vez, em rodízio. A cada carregamento da página
// (refresh do site / abertura do app) a vez passa para a próxima oferta da
// lista, na ordem da API. Dentro do mesmo carregamento a oferta escolhida fica
// fixa — navegar entre curso e aulas não troca o card na frente do aluno.
let requestSeq = 0

const ROTATION_KEY = 'vxl:rec-rotation:'
// enrollId → offerId escolhido NESTE carregamento da página.
const chosenThisLoad = {}

function readRotation (enrollId) {
  try {
    return JSON.parse(localStorage.getItem(ROTATION_KEY + enrollId)) || null
  } catch (e) {
    return null
  }
}

function writeRotation (enrollId, value) {
  try {
    localStorage.setItem(ROTATION_KEY + enrollId, JSON.stringify(value))
  } catch (e) { /* storage indisponível: o rodízio só não persiste */ }
}

// Próxima oferta depois da última exibida. Se a última saiu da lista (o aluno
// comprou, p.ex.), quem ocupa a posição dela é a "próxima" natural.
export function nextRotationIndex (items, last) {
  if (!items.length) return -1
  if (!last) return 0
  const idx = items.findIndex((i) => i.offerId === last.offerId)
  if (idx > -1) return (idx + 1) % items.length
  const pos = Number.isInteger(last.position) ? last.position : 0
  return pos % items.length
}

function pickForThisLoad (enrollId, items) {
  if (!items.length) return null

  const kept = chosenThisLoad[enrollId]
  if (kept != null && items.some((i) => i.offerId === kept)) return kept

  const index = nextRotationIndex(items, readRotation(enrollId))
  const offerId = items[index].offerId
  chosenThisLoad[enrollId] = offerId
  writeRotation(enrollId, { offerId, position: index })
  return offerId
}

export default {
  namespaced: true,
  state: {
    enrollId: null,
    items: [],
    selectedOfferId: null
  },
  getters: {
    // Lista para os componentes: só a oferta da vez (0 ou 1 item).
    itemsFor: (state) => (enrollId) => {
      if (enrollId == null || state.enrollId == null) return []
      if (String(state.enrollId) !== String(enrollId)) return []
      const selected = state.items.find((i) => i.offerId === state.selectedOfferId)
      return selected ? [selected] : []
    }
  },
  mutations: {
    SET (state, { enrollId, items, selectedOfferId }) {
      state.enrollId = enrollId
      state.items = items
      state.selectedOfferId = selectedOfferId == null ? null : selectedOfferId
    }
  },
  actions: {
    async fetch ({ commit, state }, enrollId) {
      if (enrollId == null) return

      const seq = ++requestSeq
      // Trocou de matrícula: limpa já. Mesma matrícula: mantém a lista atual
      // até a resposta chegar, pra não piscar.
      if (String(state.enrollId) !== String(enrollId)) {
        commit('SET', { enrollId, items: [] })
      }

      try {
        const items = await RecommendationService.getByEnroll(enrollId)
        if (seq !== requestSeq) return
        commit('SET', { enrollId, items, selectedOfferId: pickForThisLoad(String(enrollId), items) })
      } catch (error) {
        // Falha da recomendação não pode atrapalhar a aula: sem toast, só log,
        // e o bloco some. 404 = matrícula de outro aluno/inexistente.
        if (seq === requestSeq) commit('SET', { enrollId, items: [] })
        console.warn('[recommendation] falha ao buscar recomendações', enrollId, error && (error.status || error.message))
      }
    },
    clear ({ commit }) {
      requestSeq++
      commit('SET', { enrollId: null, items: [] })
    }
  }
}
